import React from 'react'

function TopButtons({setQuery}) {
    const cities = [
        {
            id: 1,
            title: "Cianjur",
        },
        {
            id: 2,
            title: "Bogor",
        }, 
        {
            id: 3,
            title: "Cirebon",
        }
    ]
  return (
    <div className='flex items-center justify-around my-3'>
        {cities.map( (city, i) => (
            <button key={city.id} className='text-white text-lg font-medium'
                    onClick={()=> setQuery({ q: city.title, units: 'metric'})}
            >
                {city.title}
            </button>
        ))} 
    </div>
  )
}

export default TopButtons